// $(()=>{
//        let itemLength = $('.SizeSwatchList .HorizontalList__Item').length;
//     let NoAvailableItemLength = $('.SizeSwatchList .HorizontalList__Item.no-available').length;
//     if(NoAvailableItemLength > 0){
//        $('a#BIS_trigger').css('display','block');
//     }
    
//   function callback(mutations,observer){
          
//            if(itemLength === NoAvailableItemLength){
//             $('button#BIS_trigger').addClass('active');
         
//            }
//   }
//   $('button#BIS_trigger').remove();
// //  $('iframe#BIS_frame').remove();
//   const targetEl = document.querySelector('body')    
//   const observer = new MutationObserver(callback);  
//    observer.observe(targetEl,{
//      childList:1,
//      attributes: true,
//      characterData:true
//    });
// });
// $(()=>{
//   function updateTrigger(){
//     let $items = $('.SizeSwatchList .HorizontalList__Item');
//     let itemLength = $items.length;
//     let noAvailableLength = $items.filter('.no-available').length;

//     if (noAvailableLength > 0) {
//       $('a#BIS_trigger').css('display', 'block');
//     } else {
//       $('a#BIS_trigger').css('display', 'none');
//     }

//     if (itemLength === noAvailableLength) {
//       $('a#BIS_trigger').addClass('active'); // работаем с a, а не с удалённой button
//     } else {
//       $('a#BIS_trigger').removeClass('active');
//     }
//   }

//   updateTrigger();

//   // слушаем конкретный контейнер вариантов, а не весь body
//   const targetEl = document.querySelector('.SizeSwatchList');
//   if (targetEl) {
//     const observer = new MutationObserver(updateTrigger);
//     observer.observe(targetEl, { childList: true, attributes: true, subtree: true });
//   }
// });
$(() => {
  function hideWaitlist() {
    $('a#BIS_trigger, button#BIS_trigger').attr('style', 'display: none !important');
  }

  function showWaitlist() {
    $('a#BIS_trigger').removeAttr('style').css('display', 'block');
  }

  function updateTrigger() {
    let $items = $('.SizeSwatchList .HorizontalList__Item');
    let itemLength = $items.length;
    let noAvailableLength = $items.filter('.no-available').length;
    let isPreorder = $('.restock-rocket-preorder-button').length > 0;

    if (isPreorder) {
      hideWaitlist();
      return;
    }

    if (noAvailableLength > 0) {
      showWaitlist();
    } else {
      $('a#BIS_trigger').css('display', 'none');
    }

    if (itemLength === noAvailableLength) {
      $('a#BIS_trigger').addClass('active');
    } else {
      $('a#BIS_trigger').removeClass('active');
    }
  }

  updateTrigger();

  const swatchEl = document.querySelector('.SizeSwatchList');
  const buyButtonsEl = document.querySelector('.ProductForm__BuyButtons');

  if (swatchEl) {
    new MutationObserver(updateTrigger).observe(swatchEl, { childList: true, attributes: true, subtree: true });
  }

  if (buyButtonsEl) {
    new MutationObserver(updateTrigger).observe(buyButtonsEl, { childList: true, subtree: true });
  }

  // Подстраховка от гонки: перепроверяем ещё раз через 1.5с после полной загрузки
  setTimeout(updateTrigger, 1500);
});
  $(document).ready(function(){

      
      $('.ProductListWrapper .Grid__Cell').each(function(){
       if ($(this).find('.ProductItem__Label').length > 0) {
           $(this).find('.ProductItem').addClass('opacityImage');
          // $(this).find('.ProductItem__Price').text('Join the waitlist');
          $(this).find('.ProductItem__Price').addClass('new-price-custom');
         
        }
      })
  

    
  });